import { Link, useLocation } from "@tanstack/react-router";
import { Icon } from "icons";
import { useTranslation } from "react-i18next";
import { DropdownMenuItem } from "ui";

export function AccountMenuPersonalWorkspaceItem() {
  const { t } = useTranslation();
  const isActive = useLocation({
    select: (location) => {
      return !location.pathname.startsWith("/orgs/");
    },
  });

  return (
    <DropdownMenuItem asChild>
      <Link to="/" className="flex justify-between">
        <span>{t("organizations.personalWorkspace")}</span>
        {isActive ? <Icon name="tabler-check" /> : null}
      </Link>
    </DropdownMenuItem>
  );
}
